import type { PackEntry } from 'types/shared';
import { SINGLE_AD_TYPE } from '../constants';

interface ValuesWithAdType {
  adType?: string;
  packsWithCreatives: PackEntry[];
}

export const resolveFreshStartAdType = (isHypothesisTesting: boolean): string =>
  isHypothesisTesting ? SINGLE_AD_TYPE : '';

/** URL params are already dropped; keep the form's ad type from being restored. */
export const withClearedAdType = <T extends ValuesWithAdType>(
  values: T,
  isHypothesisTesting: boolean
): T => {
  const adType = resolveFreshStartAdType(isHypothesisTesting);

  return {
    ...values,
    adType,
    packsWithCreatives: values.packsWithCreatives.map((pack) => ({
      ...pack,
      adType,
    })),
  };
};
